module.exports = __webpack_public_path__ + "static/trees-021de60c5abef604f3d33f3b47f7746e.png";